import * as yup from "yup";
import { withFormik } from "formik";

const EditSubscriptionEnhancer = withFormik({
  validationSchema: yup.object().shape({
    name: yup.string().required("Please enter package name"),
    price: yup
      .number()
      .typeError("Please enter number only for price")
      .required("Please enter package price")
      .min(1, "Price should not be equal to zero"),
    price_per_user: yup
      .number()
      .typeError("Please enter number only for price per user")
      .required("Please enter price per user")
      .min(1, "Price per user should not be equal to zero"),
    description: yup.string().required("Please enter package description")
  }),
  mapPropsToValues: props => ({
    name: "",
    price: 0,
    price_per_user: 0,
    description: ""
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});
export default EditSubscriptionEnhancer;
